import { render, staticRenderFns } from "./SwitchTeamModal.vue?vue&type=template&id=0db9d2b0&"
import script from "./SwitchTeamModal.vue?vue&type=script&lang=js&"
export * from "./SwitchTeamModal.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTeamModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports